import React, { useEffect, useState } from "react";
import { sitePath } from "../../lib/siteRouting";
import SiteLayout from "../../components/site/SiteLayout";
import { Link } from "react-router-dom";
import publicApi from "../../api/public";
import { Star, ArrowRight, Quote, Facebook, Twitter, Instagram } from "lucide-react";
import SEOHead from "../../components/site/SEOHead";

const TESTIMONIALS = [
  {
    name: "Babacar Diop",
    role: "Comptable",
    text: "TPCO Sénégal a été notre choix pour trouver la villa de nos rêves à Dakar, et nous n'aurions pas pu être plus satisfaits. Leur expertise en immobilier de prestige est indéniable, et ils ont su comprendre nos besoins spécifiques.",
  },
  {
    name: "Dior Ba",
    role: "Secrétaire",
    text: "TPCO Sénégal est véritablement un leader dans le domaine de l'immobilier de prestige au Sénégal. Leur approche personnalisée et leur connaissance approfondie du marché immobilier local les distinguent.",
  },
  {
    name: "Lamine Bassam",
    role: "Conseiller",
    text: "J'ai eu la chance de confier mon terrain à TPCO pour le montage d'une SCI, et je n'aurais pas pu être plus satisfait. Leur équipe dévouée a géré chaque détail avec professionnalisme, transformant mon actif immobilier en une opportunité d'investissement lucrative.",
  },
];

const STATS = [
  { value: "1", label: "Groupe" },
  { value: "4", label: "Réseau d'excellence" },
  { value: "3", label: "Entités" },
  { value: "100%", label: "Service clé en main" },
];

const TEAM = [
  {
    name: "Khadim Rassoul Mbodji",
    role: "CO-gérant",
    photo: "/team/khadim.jpg",
    bio:
      "Avant de se lancer dans la création de Touba Pro Construction, Khadim a pu cumuler de nombreuses expériences professionnelles, qui lui ont été accessibles après avoir obtenu brillamment son titre d'ingénieur au sein de la CNAM (Conservatoire National des Arts et Métiers), Grande École d'Ingénieur spécialisée dans le BTP. Grâce à des expériences en tant qu'Ingénieur conducteur Travaux, Khadim s'est vu proposer un poste en tant que Chargé d'affaires Travaux gros œuvre. Il occupa ce poste au sein d'un grand groupe français BGC pendant 4 ans. Au total, Khadim a eu neuf années d'expérience au sein du groupe BGC. Suite à cela, il a fait évoluer sa carrière en s'aventurant dans l'entrepreneuriat en créant Touba Construction France, spécialisée dans les travaux de gros œuvre (bâtiment industriel) et agencement depuis 2018. C'est riche de ces expériences et d'un parcours professionnel complet que Khadim a su qu'il avait toute la légitimité de créer Touba Pro Construction au Sénégal (TPCO).",
  },
  {
    name: "Ndella Diakhate Mbodji",
    role: "CO-gérante",
    photo: "/team/ndella.jpg",
    bio:
      "Ndella DIAKHATE est diplômée en tant qu'ingénieure génie civil à l'Université Pierre et Marie Curie de Paris jumelée à l'École Normale Supérieure de CACHAN. Elle dispose de neuf années d'expérience en tant qu'ingénieure en Bureau d'études. Ndella a débuté sa carrière professionnelle en tant qu'ingénieure en calcul de structure chez SOMETE bureau d'études pendant 4 ans. Force de proposition et d'implication sur ses projets, elle obtient une promotion pour occuper le poste de chargée d'affaires pendant 5 ans. Durant son parcours professionnel, Ndella a eu l'occasion de gérer de nombreux projets dans le domaine du BTP et de tailles diverses, mais aussi de travailler aussi bien avec les décisionnaires de grands groupes qu'avec des collaborateurs de plus petites structures mandatées en sous-traitance. Elle apporte à l'équipe un bagage professionnel complet en ce qui concerne les matériaux et les structures, mais aussi une grande expérience concernant la gestion des hommes sur les chantiers.",
  },
];

const AGENTS = [
  { name: "Farid Siré", role: "Agent Immobilier", photo: "/team/tcpo7.jpg" },
  { name: "Ndella DIAKHATE", role: "Agent Immobilier", photo: "/team/tcpo4.jpg" },
  { name: "Majib Massamba", role: "Agent Immobilier", photo: "/team/tcpo5.jpg" },
];

export default function QuiSommesNous() {
  const [agents, setAgents] = useState(null);

  useEffect(() => {
    publicApi.get("/agents")
      .then(({ data }) => setAgents(data || []))
      .catch(() => setAgents([]));  // si endpoint inactif, fallback aux statiques
  }, []);

  // Si l'admin n'a configuré aucun agent, on retombe sur la liste statique d'origine
  const displayedAgents = (agents && agents.length > 0) ? agents : AGENTS;

  return (
    <SiteLayout>
      <SEOHead
        title="Qui sommes-nous"
        description="TPCO Sénégal — Touba Pro Construction. Entreprise née d'une véritable passion pour le bâtiment et le génie civil. Notre savoir-faire repose sur nos compétences et expériences en Europe."
      />

      {/* Breadcrumb */}
      <div className="bg-[#F1F3FB] border-b border-[#E2E5F1] py-6">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 text-xs text-[#4B5775]">
          <Link to={sitePath("")} className="hover:text-[#1E3A8A]">Accueil</Link> /{" "}
          <span className="text-[#0F1A3D] font-semibold">Qui sommes-nous ?</span>
        </div>
      </div>

      {/* Intro */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20" data-testid="qsn-intro">
        <div className="text-[14px] text-[#2E64A5] font-bold mb-3 tracking-wider">// À PROPOS DE NOUS</div>
        <h1
          className="font-display text-4xl lg:text-[56px] font-extrabold leading-[1.05] tracking-tight mb-3"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          TPCO — L'entreprise<br />Touba Pro Construction à Dakar
        </h1>
        <h2
          className="font-display text-xl lg:text-2xl text-[#4B5775] font-semibold mb-10"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          L'entreprise Touba Pro Construction
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="space-y-5 text-[15px] text-[#4B5775] leading-[1.85]">
            <p>
              L'entreprise <strong className="text-[#0F1A3D]">Touba Pro Construction TPCO SÉNÉGAL</strong> est née d'une
              véritable passion pour le bâtiment et le génie civil. Notre savoir-faire repose sur nos compétences et
              expériences en Europe, mais aussi sur nos partenaires en bureau d'études pour la réalisation des plans
              d'exécution et études d'avant-projet.
            </p>
            <p className="font-semibold text-[#0F1A3D]">Nous réalisons :</p>
            <ul className="space-y-2 ml-4 list-disc marker:text-[#E91E63]">
              <li>Des travaux neufs (bâtiment et ouvrages de génie civil)</li>
              <li>Travaux de réhabilitation dans la grande Distribution</li>
              <li>Construction et agencement de maison individuelle et rénovation</li>
            </ul>
            <p>
              La société réalise aussi bien des travaux neufs (bâtiment industriel et ouvrage de génie civil), que des
              travaux de réhabilitation dans la grande Distribution et aussi dans la construction et agencement de
              maison individuelle et rénovation.
            </p>
            <p>
              Quel que soit votre projet, l'entreprise <strong className="text-[#0F1A3D]">TPCO SÉNÉGAL</strong> vous
              accompagne, identifie l'ensemble de vos besoins et vous propose une étude et un chiffrage personnalisé
              répondant à votre attente.
            </p>
          </div>
          <div className="bg-[#2E64A5] text-white p-10 relative">
            <Quote className="w-14 h-14 text-white/20 absolute top-6 right-6" strokeWidth={1.5} />
            <div className="text-[11px] uppercase tracking-[0.25em] text-white/70 font-bold mb-4">Notre philosophie</div>
            <p
              className="font-display text-xl lg:text-2xl italic leading-[1.5]"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              « Réaliser des prestations de qualité dans une recherche constante de la satisfaction du client. »
            </p>
            <p className="text-sm text-white/85 mt-6 leading-relaxed">
              Un de nos atouts majeurs est notre capacité à nous adapter aux contraintes du client ou du projet tout en
              respectant la synthèse et la coactivité avec les autres corps d'état. Les travaux de gros-œuvre liés à
              des reprises en sous-œuvre, des extensions et surélévations ou encore des travaux plus « décoratifs »
              comme les revêtements de sols ou de murs sont notre quotidien. La satisfaction de nos clients est notre
              principal objectif, tant sur la sécurité, la qualité de réalisation que sur le respect des délais ou la
              réactivité d'intervention — le tout avec professionnalisme et exigence.
            </p>
          </div>
        </div>
      </section>

      {/* CTA stat band */}
      <section className="bg-[#0F1A3D] text-white py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="text-[11px] uppercase tracking-[0.25em] text-[#E91E63] font-bold mb-3">// TPCO Sénégal</div>
              <h3
                className="font-display text-3xl lg:text-4xl font-bold leading-tight mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Comptez sur notre savoir-faire pour vous aider.
              </h3>
              <p className="text-white/70 leading-relaxed mb-6">
                Fortement investis dans l'univers de l'immobilier haut de gamme, nous concevons nos projets de manière
                exhaustive, en exploitant nos compétences variées. Notre engagement envers des normes élevées assure à
                nos clients la possession de biens exceptionnels, parfaitement adaptés à leurs attentes.
              </p>
              <Link
                to={sitePath("/contact")}
                className="inline-flex items-center gap-2 h-12 px-6 bg-[#E91E63] hover:bg-[#D81B60] text-white text-[13px] font-bold uppercase tracking-wider"
              >
                En savoir plus <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-px bg-white/10">
              {STATS.map((s, i) => (
                <div key={i} className="bg-[#0F1A3D] py-10 text-center">
                  <div
                    className="font-display text-5xl lg:text-6xl font-extrabold text-white"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {s.value}
                  </div>
                  <div className="text-xs uppercase tracking-wider text-white/60 font-semibold mt-2">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Équipe / Co-gérants — layout compact 2 colonnes */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16" data-testid="qsn-cogerants">
        <div className="text-[14px] text-[#2E64A5] font-bold mb-3 tracking-wider">// NOS DIRIGEANTS</div>
        <h2
          className="font-display text-3xl lg:text-4xl font-extrabold leading-tight tracking-tight mb-10"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Rencontrez nos co-gérants
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {TEAM.map((m, i) => (
            <article key={i} className="bg-white border border-[#E2E5F1] overflow-hidden flex flex-col sm:flex-row">
              <div className="sm:w-44 shrink-0">
                <div className="aspect-[3/4] sm:aspect-auto sm:h-full overflow-hidden bg-[#0F1A3D]">
                  {m.photo ? (
                    <img src={m.photo} alt={m.name} className="w-full h-full object-cover" loading="lazy" />
                  ) : (
                    <div
                      className="w-full h-full bg-gradient-to-br from-[#1E3A8A] to-[#3B5BBE] flex items-center justify-center text-white font-display text-5xl font-extrabold"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {m.name.split(" ").map((p) => p[0]).slice(0, 2).join("")}
                    </div>
                  )}
                </div>
              </div>
              <div className="p-5 flex-1 min-w-0">
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#E91E63] font-bold mb-1.5">// {m.role}</div>
                <h3
                  className="font-display text-xl lg:text-2xl font-extrabold mb-2.5 tracking-tight leading-tight"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {m.name}
                </h3>
                <p className="text-[#4B5775] leading-[1.65] text-[13px] line-clamp-[10] sm:line-clamp-[12]">{m.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* CTA inline */}
      <section className="bg-[#F8FAFC] py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <h3
            className="font-display text-2xl lg:text-3xl font-extrabold tracking-tight max-w-3xl"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Quel que soit votre projet, l'entreprise TPCO SÉNÉGAL vous accompagne.
          </h3>
          <Link
            to={sitePath("/contact")}
            className="inline-flex items-center gap-2 h-12 px-6 bg-[#E91E63] hover:bg-[#D81B60] text-white text-[13px] font-bold uppercase tracking-wider shrink-0"
          >
            Commençons dès maintenant <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      {/* Nos Agents */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20" data-testid="qsn-agents">
        <div className="text-[14px] text-[#2E64A5] font-bold mb-3 tracking-wider">// NOS AGENTS</div>
        <h2
          className="font-display text-3xl lg:text-5xl font-extrabold leading-tight tracking-tight mb-12"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Rencontrez nos agents
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {displayedAgents.map((a, i) => {
            // Normalisation des champs (mode dynamique backend vs statique fallback)
            const name = a.nom || a.name;
            const role = a.role;
            const photo = a.photo_url || a.photo;
            const fb = a.facebook_url;
            const tw = a.twitter_url;
            const ig = a.instagram_url;
            return (
            <div key={a.id || i} className="bg-white border border-[#E2E5F1] overflow-hidden hover:shadow-lg transition group" data-testid={`agent-card-${i}`}>
              <div className="aspect-[3/4] overflow-hidden bg-[#0F1A3D]">
                {photo ? (
                  <img
                    src={photo}
                    alt={name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <div
                    className="w-full h-full bg-gradient-to-br from-[#1E3A8A] via-[#2E64A5] to-[#E91E63] flex items-center justify-center text-white font-display text-7xl font-extrabold group-hover:scale-105 transition-transform duration-500"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {(name || "?").split(" ").map((p) => p[0]).slice(0, 2).join("")}
                  </div>
                )}
              </div>
              <div className="p-6 text-center">
                <div className="h-px w-12 bg-[#E91E63] mx-auto mb-4" />
                <h3
                  className="font-display text-xl font-extrabold text-[#0F1A3D] mb-1"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {name}
                </h3>
                <div className="text-xs text-[#4B5775] uppercase tracking-[0.2em] mb-4">{role}</div>
                <div className="flex items-center justify-center gap-3 text-[#4B5775]">
                  <a href={fb || "#"} target={fb ? "_blank" : undefined} rel="noopener noreferrer" aria-label="Facebook" className={`hover:text-[#1E3A8A] transition ${!fb ? "opacity-30 cursor-default" : ""}`}><Facebook className="w-4 h-4" /></a>
                  <a href={tw || "#"} target={tw ? "_blank" : undefined} rel="noopener noreferrer" aria-label="Twitter" className={`hover:text-[#1E3A8A] transition ${!tw ? "opacity-30 cursor-default" : ""}`}><Twitter className="w-4 h-4" /></a>
                  <a href={ig || "#"} target={ig ? "_blank" : undefined} rel="noopener noreferrer" aria-label="Instagram" className={`hover:text-[#1E3A8A] transition ${!ig ? "opacity-30 cursor-default" : ""}`}><Instagram className="w-4 h-4" /></a>
                </div>
              </div>
            </div>
          );})}
        </div>
      </section>

      {/* Témoignages */}
      <section className="bg-[#F8FAFC] py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="text-[14px] text-[#2E64A5] font-bold mb-3 tracking-wider">// NOS TÉMOIGNAGES</div>
          <h2
            className="font-display text-3xl lg:text-5xl font-extrabold leading-tight tracking-tight mb-12"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Avis clients
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {TESTIMONIALS.map((t, i) => (
              <div key={i} className="bg-white border border-[#E2E5F1] p-8 hover:shadow-lg transition">
                <div className="flex items-center gap-1 text-[#D48A37] mb-4">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} className="w-4 h-4 fill-[#D48A37]" />
                  ))}
                </div>
                <p className="text-sm text-[#4B5775] leading-relaxed italic mb-6">"{t.text}"</p>
                <div className="pt-4 border-t border-[#E2E5F1]">
                  <div className="font-display text-lg font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {t.name}
                  </div>
                  <div className="text-xs text-[#4B5775] uppercase tracking-wider mt-1">{t.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA bas */}
      <section className="bg-[#2E64A5] text-white py-16 text-center">
        <h2
          className="font-display text-3xl lg:text-4xl font-extrabold mb-6 max-w-3xl mx-auto px-6"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Quel que soit votre projet, l'entreprise TPCO SÉNÉGAL vous accompagne.
        </h2>
        <Link
          to={sitePath("/contact")}
          className="inline-flex items-center gap-2 h-12 px-8 bg-[#E91E63] hover:bg-[#D81B60] text-white text-[13px] font-bold uppercase tracking-wider"
        >
          Commençons dès maintenant <ArrowRight className="w-4 h-4" />
        </Link>
      </section>
    </SiteLayout>
  );
}
